import { useEffect, useRef } from "react";

// Das Preview-Overlay der Plattform entfernt in der Vorschau dynamische
// src-Attribute auf <img>. Diese Komponente setzt src explizit nach dem Mount.
export default function BrandImage({ src, srcSet, sizes, alt, className = "", width, height, loading = "lazy", fetchPriority }) {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (el && !el.getAttribute("src")) {
      el.setAttribute("src", src);
    }
  }, [src]);
  return (
    <img
      ref={ref}
      src={src}
      srcSet={srcSet}
      sizes={sizes}
      alt={alt}
      width={width}
      height={height}
      loading={loading}
      decoding="async"
      fetchPriority={fetchPriority}
      className={className}
    />
  );
}
